const routes = [
  {
    path: 'billing-app',
    component: () => import(/* webpackChunkName: "billing-app" */ './views/Index.vue'),
    meta: {
      permissionRequired: true,
    },
    children: [
      {
        path: '',
        name: 'billingApp',
        component: () => import(/* webpackChunkName: "billing-app" */ './views/Dashboard.vue'),
      },
      {
        path: 'master-data',
        alias: '/master-data',
        name: 'billingMasterData',
        component: () => import(/* webpackChunkName: "billing-app" */ './views/MasterData.vue'),
        children: [
          {
            path: '',
            name: 'billingRateList',
            component: () => import(/* webpackChunkName: "billing-app" */ './components/rates/RateList.vue'),
          },
          {
            path: 'rates/new',
            alias: '/master-data/rates/new',
            name: 'billingRateCreate',
            component: () => import(/* webpackChunkName: "billing-app" */ './components/rates/RateForm.vue'),
          },
          {
            path: 'rates/:id/edit',
            alias: '/master-data/rates/:id/edit',
            name: 'billingRateEdit',
            component: () => import(/* webpackChunkName: "billing-app" */ './components/rates/RateForm.vue'),
            props: true,
          },
        ],
      },
      {
        path: 'billing-entry',
        alias: '/billing-entry',
        name: 'billingEntry',
        component: () => import(/* webpackChunkName: "billing-app" */ './views/BillingEntry.vue'),
      },
      {
        path: 'billing-history',
        alias: '/billing-history',
        name: 'billingHistory',
        component: () => import(/* webpackChunkName: "billing-app" */ './views/BillingHistory.vue'),
        children: [
          {
            path: '',
            name: 'billingList',
            component: () => import(/* webpackChunkName: "billing-app" */ './components/billing/BillingList.vue'),
          },
          {
            path: ':id',
            alias: '/billing-history/:id',
            name: 'billingDetail',
            component: () => import(/* webpackChunkName: "billing-app" */ './components/billing/BillingDetail.vue'),
            props: true,
          },
          {
            path: ':id/edit',
            alias: '/billing-history/:id/edit',
            name: 'billingEdit',
            component: () => import(/* webpackChunkName: "billing-app" */ './views/BillingEdit.vue'),
            props: true,
          },
        ],
      },
      {
        path: 'dg-billing-entry',
        alias: '/dg-billing-entry',
        name: 'dgBillingEntry',
        component: () => import(/* webpackChunkName: "billing-app" */ './views/DGBillingEntry.vue'),
      },
      {
        path: 'dg-billing-history',
        alias: '/dg-billing-history',
        name: 'dgBillingHistory',
        component: () => import(/* webpackChunkName: "billing-app" */ './views/DGBillingHistory.vue'),
        children: [
          {
            path: '',
            name: 'dgBillingList',
            component: () => import(/* webpackChunkName: "billing-app" */ './components/dg/DGBillingList.vue'),
          },
          {
            path: ':id',
            alias: '/dg-billing-history/:id',
            name: 'dgBillingDetail',
            component: () => import(/* webpackChunkName: "billing-app" */ './components/dg/DGBillingDetail.vue'),
            props: true,
          },
          {
            path: ':id/edit',
            alias: '/dg-billing-history/:id/edit',
            name: 'dgBillingEdit',
            component: () => import(/* webpackChunkName: "billing-app" */ './views/DGBillingEdit.vue'),
            props: true,
          },
        ],
      },
    ],
  },
];

export default routes;
